var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{attrs:{"id":"components-layout-demo-top-side-2"}},[_c('Sider'),_c('a-layout',[_c('Header'),_c('a-layout',{staticClass:"bodyContnet",style:({ padding: '40px 40px 20px 40px' }),attrs:{"id":"bodyContnet"}},[_c('a-layout-content',{staticClass:"components-layout-content",style:({
          padding: '0px',
          overflowY: 'auto',
          overflowX: 'hidden',
          height: '100%',
        }),attrs:{"id":"components-layout-content"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }